import React from "react";
import { createRoot } from "react-dom/client";

import "@datamole/wds-css-normalize/normalize.css";
import "@datamole/wds-css-theme-datamole/datamole.theme.css";

import { App } from "@/App";

// eslint-disable-next-line no-console
console.log(`office-map v${APP_VERSION} on ${import.meta.env.MODE} environment`);

createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
